import { USER_ROLES } from "@nlc/shared-types";
import { Bot, CalendarCheck2, Eye, Paintbrush } from "lucide-react";

import Award from "./icons/award.svg?react";
import BarChart from "./icons/bar-chart.svg?react";
import Bell from "./icons/bell.svg?react";
import BriefCase from "./icons/briefcase.svg?react";
import Folder from "./icons/folder.svg?react";
import GraduationCap from "./icons/graduation-hat.svg?react";
import Heart from "./icons/heart.svg?react";
import Home from "./icons/home.svg?react";
import Laptop from "./icons/laptop.svg?react";
import Layers from "./icons/layers-two.svg?react";
import Settings from "./icons/settings.svg?react";
import Trash from "./icons/trash.svg?react";
import User from "./icons/user.svg?react";
import Users from "./icons/users.svg?react";

const ITEM_DASHBOARD = {
  href: "/dashboard",
  icon: Home,
  label: "Dashboard",
};
const ITEM_REQUESTS = {
  href: "/requests",
  icon: Layers,
  label: "Requests",
};
const ITEM_PUBLISH = {
  href: "/publish",
  icon: CalendarCheck2,
  label: "Publish",
};
const ITEM_NOTIFICATIONS = {
  href: "/notifications",
  icon: Bell,
  label: "Notifications",
};
const ITEM_BRANDS = { href: "/brands", icon: Award, label: "Brands" };
const ITEM_USERS = { href: "/users", icon: User, label: "Users" };
const ITEM_TEAMS = { href: "/teams", icon: Users, label: "Teams" };
const ITEM_ACCOUNTS = {
  href: "/projects",
  icon: BriefCase,
  label: "Accounts",
};
const ITEM_ISSUES = {
  href: "/issues-reports",
  icon: BarChart,
  label: "Issues",
};
const ITEM_MY_DESIGNERS = {
  href: "/profile/designer-preference",
  icon: Heart,
  label: "My designers",
};
const ITEM_MY_FILES = {
  href: "/my-files",
  icon: Folder,
  label: "My files",
};
const ITEM_MY_SITES = {
  href: "/my-sites",
  icon: Laptop,
  label: "My sites",
};
const ITEM_UNIVERSITY = {
  href: "https://nlc.com/nolimit-university",
  icon: GraduationCap,
  label: "University",
};
const ITEM_TRASH = { href: "/trash", icon: Trash, label: "Trash" };
const ITEM_SETTINGS_DCC = {
  href: "/admin/confidence-checker",
  icon: Eye,
  label: "DCC",
};
const ITEM_SETTINGS_MBC = { href: "/admin/mbc", icon: Bot, label: "MBC" };
const ITEM_SETTINGS_SUBCATEGORIES = {
  href: "/admin/subcategories",
  icon: Folder,
  label: "Subcategories",
};
const ITEM_SETTINGS_DESIGN_TYPES = {
  href: "/admin/design-types",
  icon: Paintbrush,
  label: "Design types",
};
const ITEM_SETTINGS = {
  children: [
    ITEM_SETTINGS_DCC,
    ITEM_SETTINGS_MBC,
    ITEM_SETTINGS_SUBCATEGORIES,
    ITEM_SETTINGS_DESIGN_TYPES,
  ],
  icon: Settings,
  label: "Settings",
};
// const ITEM_WHITE_LABEL = {
//   href: "/whitelabel",
//   icon: Laptop,
//   label: "Whitelabel",
// };

// Customer Roles
const ownerNavItems = [
  ITEM_REQUESTS,
  ITEM_PUBLISH,
  ITEM_NOTIFICATIONS,
  ITEM_BRANDS,
  ITEM_USERS,
  ITEM_MY_DESIGNERS,
  ITEM_MY_FILES,
  ITEM_MY_SITES,
  ITEM_UNIVERSITY,
];

const adminNavItems = [
  ITEM_REQUESTS,
  ITEM_PUBLISH,
  ITEM_NOTIFICATIONS,
  ITEM_BRANDS,
  ITEM_USERS,
  ITEM_MY_DESIGNERS,
  ITEM_MY_FILES,
  ITEM_MY_SITES,
  ITEM_UNIVERSITY,
];

const collaboratorNavItems = [
  ITEM_REQUESTS,
  ITEM_PUBLISH,
  ITEM_NOTIFICATIONS,
  ITEM_BRANDS,
  ITEM_MY_DESIGNERS,
  ITEM_MY_SITES,
  ITEM_UNIVERSITY,
];

// Team Roles
const superAdminNavItems = [
  ITEM_DASHBOARD,
  ITEM_REQUESTS,
  ITEM_NOTIFICATIONS,
  ITEM_BRANDS,
  ITEM_USERS,
  ITEM_TEAMS,
  ITEM_ACCOUNTS,
  ITEM_ISSUES,
  ITEM_UNIVERSITY,
  ITEM_TRASH,
  ITEM_SETTINGS,
  // ITEM_WHITE_LABEL,
];

const customerSuccessNavItems = [
  ITEM_DASHBOARD,
  ITEM_REQUESTS,
  ITEM_NOTIFICATIONS,
  ITEM_BRANDS,
  ITEM_USERS,
  ITEM_ACCOUNTS,
  ITEM_ISSUES,
  ITEM_UNIVERSITY,
  ITEM_TRASH,
];

const teamLeaderNavItems = [
  ITEM_DASHBOARD,
  ITEM_REQUESTS,
  ITEM_NOTIFICATIONS,
  ITEM_BRANDS,
  ITEM_USERS,
  ITEM_ACCOUNTS,
  ITEM_ISSUES,
  ITEM_UNIVERSITY,
  ITEM_TRASH,
];

const designerNavItems = [
  ITEM_DASHBOARD,
  ITEM_REQUESTS,
  ITEM_NOTIFICATIONS,
  ITEM_BRANDS,
  ITEM_ACCOUNTS,
  ITEM_UNIVERSITY,
];

export const NAV_ITEMS = {
  [USER_ROLES.ADMIN]: adminNavItems,
  [USER_ROLES.COLLABORATOR]: collaboratorNavItems,
  [USER_ROLES.CUSTOMER_SUCCESS]: customerSuccessNavItems,
  [USER_ROLES.DESIGNER]: designerNavItems,
  [USER_ROLES.OWNER]: ownerNavItems,
  [USER_ROLES.SUPER_ADMIN]: superAdminNavItems,
  [USER_ROLES.TEAM_LEADER]: teamLeaderNavItems,
};

/**
 * External NLC-specific hrefs that should be hidden for whitelabel users.
 * These include NLC marketing pages, Google Drive links, and help center links.
 */
export const NLC_ONLY_ITEMS = new Set<object>([ITEM_UNIVERSITY, ITEM_MY_SITES]);

export const SOCIAL_PUBLISHING_ITEMS = new Set<object>([ITEM_PUBLISH]);
